var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 6,
    fill: "#EFF6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1722_27183",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H7V27H27V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1722_27183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3313 25.9598H13.6646C9.81458 25.9598 9.09791 24.1681 8.91458 22.4265L8.28958 15.7515C8.19791 14.8764 8.17291 13.5848 9.03958 12.6181C9.78958 11.7848 11.0312 11.3848 12.8312 11.3848H21.1646C22.9729 11.3848 24.2146 11.7931 24.9563 12.6181C25.8229 13.5848 25.7979 14.8764 25.7063 15.7598L25.0813 22.4181C24.8979 24.1681 24.1813 25.9598 20.3313 25.9598ZM12.8312 12.6264C11.4229 12.6264 10.4562 12.9014 9.96458 13.4514C9.55624 13.9014 9.42291 14.5931 9.53124 15.6265L10.1562 22.3015C10.2979 23.6181 10.6562 24.7098 13.6646 24.7098H20.3313C23.3313 24.7098 23.6979 23.6181 23.8396 22.2931L24.4646 15.6348C24.5729 14.5931 24.4396 13.9014 24.0313 13.4514C23.5396 12.9014 22.5729 12.6264 21.1646 12.6264H12.8312Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3307 12.6263C19.9891 12.6263 19.7057 12.343 19.7057 12.0013V11.3346C19.7057 9.8513 19.7057 9.29297 17.6641 9.29297H16.3307C14.2891 9.29297 14.2891 9.8513 14.2891 11.3346V12.0013C14.2891 12.343 14.0057 12.6263 13.6641 12.6263C13.3224 12.6263 13.0391 12.343 13.0391 12.0013V11.3346C13.0391 9.86797 13.0391 8.04297 16.3307 8.04297H17.6641C20.9557 8.04297 20.9557 9.86797 20.9557 11.3346V12.0013C20.9557 12.343 20.6724 12.6263 20.3307 12.6263Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9987 20.9583C14.707 20.9583 14.707 19.5417 14.707 18.6917V17.8333C14.707 16.6583 14.9904 16.375 16.1654 16.375H17.832C19.007 16.375 19.2904 16.6583 19.2904 17.8333V18.6667C19.2904 19.5333 19.2904 20.9583 16.9987 20.9583ZM15.957 17.625C15.957 17.6917 15.957 17.7667 15.957 17.8333V18.6917C15.957 19.55 15.957 19.7083 16.9987 19.7083C18.0404 19.7083 18.0404 19.575 18.0404 18.6833V17.8333C18.0404 17.7667 18.0404 17.6917 18.0404 17.625C17.9737 17.625 17.8987 17.625 17.832 17.625H16.1654C16.0987 17.625 16.0237 17.625 15.957 17.625Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6643 19.3089C18.356 19.3089 18.081 19.0755 18.0476 18.7589C18.006 18.4172 18.2476 18.1005 18.5893 18.0589C20.7893 17.7839 22.8976 16.9505 24.6726 15.6589C24.9476 15.4505 25.3393 15.5172 25.5476 15.8005C25.7476 16.0755 25.6893 16.4672 25.406 16.6755C23.456 18.0922 21.156 19.0005 18.7393 19.3089C18.7143 19.3089 18.6893 19.3089 18.6643 19.3089Z",
    fill: "#002857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.332 19.3174C15.307 19.3174 15.282 19.3174 15.257 19.3174C12.9736 19.0591 10.7486 18.2257 8.82365 16.9091C8.54032 16.7174 8.46532 16.3257 8.65698 16.0424C8.84865 15.7591 9.24032 15.6841 9.52365 15.8757C11.282 17.0757 13.307 17.8341 15.3903 18.0757C15.732 18.1174 15.982 18.4257 15.9403 18.7674C15.9153 19.0841 15.6487 19.3174 15.332 19.3174Z",
    fill: "#002857"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.de8bb33e1e12f8dbb96ceb27f1f69679.svg";
export { ForwardRef as ReactComponent };